import { Component } from '@angular/core';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet><ngx-spinner type="pacman"></ngx-spinner>'
})
export class AppComponent { }
